<ng-template #noOrder>
  <div class="menu-item-list no-drag">
    <div *ngFor="let installedApp of installedApps; let i = index" class="menu-item">
      <ng-container *ngTemplateOutlet="installedAppListItem;context:{ installedApp, i }"></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #installedAppListItem let-i="i" let-installedApp="installedApp">
  <div class="title">{{ installedApp.title }}</div>
  <mat-icon *ngIf="installedApp?.packageInstalledApp?.isSecured" class="lock" matTooltip="{{'packages.installedApps.secureTip'| translate}}">group</mat-icon>
  <mat-chip-listbox>
    <mat-chip-option *ngIf="checkActive(installedApp.packageInstalledApp) === 'active'" class="live">{{ 'general.publish.online' | translate }}</mat-chip-option>
    <mat-chip-option *ngIf="checkActive(installedApp.packageInstalledApp) === 'paused' && !installedApp.packageInstalledApp.disabled" class="paused">{{ 'general.publish.paused' | translate }}</mat-chip-option>
    <mat-chip-option *ngIf="checkActive(installedApp.packageInstalledApp) === 'disabledInherited' ||  installedApp.packageInstalledApp.disabled" class="disabled">{{ 'general.publish.disabled' | translate }}</mat-chip-option>
  </mat-chip-listbox>
  <button *ifPrivilege="{name: 'write', value: 'packages'}" class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
    <mat-icon>drag_indicator</mat-icon>
  </button>

  <button (click)="select(i)" *ngIf="packageId === installedApp.packageInstalledApp.packageId" class="edit ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.editTip'| translate}}">
    <mat-icon>edit</mat-icon>
  </button>

  <button *ngIf="!superadmin && packageId !== installedApp.packageInstalledApp.packageId" class="edit ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.editMasterPackageTip'| translate}}">
    <mat-icon>not_interested</mat-icon>
  </button>

  <ng-container *ngIf="superadmin && packageId !== installedApp.packageInstalledApp.packageId">
    <mat-checkbox (change)="toggleMasterPackageApp(installedApp.packageInstalledApp._id)"
                  [checked]="!package.disabledInheritedAppIds || (!!package.disabledInheritedAppIds && package.disabledInheritedAppIds.indexOf(installedApp.packageInstalledApp._id) === -1)"
                  matTooltip="{{'packages.installedApps.' + (!package.disabledInheritedAppIds || (!!package.disabledInheritedAppIds && package.disabledInheritedAppIds.indexOf(installedApp.packageInstalledApp._id) === -1) ? 'disable' : 'enable') + 'InheritedApp'| translate}}"></mat-checkbox>
  </ng-container>
</ng-template>

<page-content *ngIf="!!package" [class.admin]="superadmin">
  <div *ngIf="superadmin && !!installedApps && installedApps.length > 0 && package.isScreenPackage && (package.isNotTouch2015ScreenPackage && package.ibexTouch.enabled)" class="fixed-select-group">
    <div class="smart-input-field dropdown">
      <mat-select [(ngModel)]="package.screen.fixedWidgetId" placeholder="{{'packages.installedApps.selectFixed' | translate}}">
        <mat-option *ngFor="let app of installedApps" [value]="app.packageInstalledApp._id">{{ app.title }}</mat-option>
      </mat-select>
    </div>
    <button (click)="resetFixedWidget()" mat-icon-button>
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div class="row">
    <div class="column left">
      <mat-card appearance="outlined" class="navItems">
        <div *ngIf="superadmin" class="button-right-container">
          <button (click)="importAllApps()" *ngIf="importAll && package.compositionIds.length" mat-mini-fab>
            <mat-icon>save_alt</mat-icon>
          </button>
          <button (click)="resetAppOrders()" mat-mini-fab matTooltip="{{'packages.installedApps.resetTip'| translate}}">
            <mat-icon>refresh</mat-icon>
          </button>
          <button (click)="openAppPicker()" mat-mini-fab
                  *ngIf="package.compositionIds.length && ( (availableCompositionApps && availableCompositionApps.length) || (availableDynamicContent && availableDynamicContent.length) || (availableCodeSnippets && availableCodeSnippets.length))">
            <mat-icon>add</mat-icon>
          </button>
          <button (click)="openAppCreator()" mat-mini-fab>
            <mat-icon>library_add</mat-icon>
          </button>
        </div>
        <mat-tab-group (selectedIndexChange)="changeActiveType($event)" *ngIf="superadmin;else noOrder" class="order-tab-group">
          <mat-tab *ngFor="let order of orders" label="{{'packages.installedApps.orders.' + order | translate}}">
            <div (cdkDropListDropped)="dropItem($event)" cdkDropList class="menu-item-list">
              <div *ngFor="let installedApp of getTypeArray(order); let i = index" cdkDrag cdkDragBoundary=".menu-item-list"
                   class="menu-item">
                <div *cdkDragPlaceholder class="drag-placeholder"></div>
                <ng-container *ngTemplateOutlet="installedAppListItem;context:{ installedApp, i, type: activeOrder }"></ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
        <div *ngIf="!installedApps || installedApps.length === 0" class="no-menu-items">
          <mat-icon>brush</mat-icon>
          <p>{{ 'general.no-data'|translate }}</p>
          <button (click)="openAppPicker()" color="primary" mat-raised-button>
            <mat-icon>create_new_folder</mat-icon>
            {{ 'packages.installedApps.add' | translate }}
          </button>
        </div>
      </mat-card>
    </div>
    <mat-card appearance="outlined" *ngIf="activeInstalledApp" class="column right">
      <mat-card-title>{{ activeInstalledApp.title }}</mat-card-title>
      <div (click)="readMe('packages-navigation-installedApp', 'packages')" class="button-right-container float-right">
        <button class="ibexfusion-icon-button help" mat-icon-button style="opacity: 0">
          <mat-icon>help</mat-icon>
        </button>
      </div>
      <ng-container *ngIf="isScreenPackage">
        <div *ngIf="!activeInstalledApp.packageInstalledWidget && !isLoading">
          <ng-container *ngTemplateOutlet="appConfig"></ng-container>
        </div>
        <mat-tab-group (selectedTabChange)="tabChange($event)" *ngIf="activeInstalledApp.packageInstalledWidget && !isLoading"
                       class="main-tab-group">
          <mat-tab label="App">
            <ng-container *ngTemplateOutlet="appConfig"></ng-container>
          </mat-tab>
          <mat-tab label="Widget">
            <app-package-installed-widget-editor (widgetSave)="onWidgetSave($event)" *ngIf="selectedIndex === 1"
                                                 [(widget)]="activeInstalledApp.packageInstalledWidget" [pak]="package"
                                                 [availableLanguages]="availableLanguages"></app-package-installed-widget-editor>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
      <ng-container *ngIf="!isScreenPackage">
        <ng-container *ngTemplateOutlet="appConfig"></ng-container>
      </ng-container>
    </mat-card>
  </div>
</page-content>

<ng-template #appConfig>
  <app-package-installed-app-editor (installedAppRemoved)="onInstalledAppRemoved($event)" [package]="package"
    [installedApp]="activeInstalledApp.packageInstalledApp" (installedAppSave)="onInstalledAppSave()"
    (resetHighscore)="onResetHighscore()" [compositionApp]="activeInstalledApp.compositionApp" [availableLanguages]="availableLanguages"
    [dynamicEntranceApp]="activeInstalledApp.dynamicContentEntranceApp" [codeSnippetApp]="activeInstalledApp.codeSnippetApp">
  </app-package-installed-app-editor>
</ng-template>
